import { createReducer } from "@reduxjs/toolkit";
import {
    getProjects,
    projectSelected,
    projectsReceived,
    statusesReceived,
    newProjectCreated,
    clearSelectedProject,
    toggleProjectsListView
} from "actions/Projects";
import { ProjectsStateInterface } from "actions/Projects/types";
import { defaultGetResponse } from "interfaces/ActionReducer/GetMethod/GetResponse";

export const initialState: ProjectsStateInterface = {
    projects: defaultGetResponse,
    selectedProject: {},
    isProjectsReceived: false,
    statusesReceived: defaultGetResponse,
    newProjectCreated: false,
    showProjectsListView: false
};

const Projects = createReducer(initialState, (builder) => {
    builder
        .addCase(projectsReceived, (state, action) => {
            state.projects = action.payload.data;
            state.isProjectsReceived = true;
        })
        .addCase(projectSelected, (state, action) => {
            state.selectedProject = action.payload.data;
        })
        .addCase(getProjects, (state, action) => {
            state.isProjectsReceived = false;
        })
        .addCase(statusesReceived, (state, action) => {
            state.statusesReceived = action.payload.data;
        })
        .addCase(newProjectCreated, (state, action) => {
            state.newProjectCreated = action.payload.isProjectCreated;
        })
        .addCase(clearSelectedProject, (state) => {
            // any possible issue, if set as empty object?
            state.selectedProject = {};
        })
        .addCase(toggleProjectsListView, (state, action) => {
            state.showProjectsListView = action.payload.showProjectsListView;
        });
});

export default Projects;
